module.exports = __webpack_public_path__ + "static/media/fundHeader.7b1243ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fundHeader.png
// module id = 2158
// module chunks = 0